import { useEffect, type FC, type ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import BrandMarkImg from './brand_mark.svg?react';
import { appFactory } from '../logic';
import { ErrorView } from '../ErrorView';
import styles from './Init.module.scss';

export const Init: FC<{ children: ReactNode }> = observer(({ children }) => {
  const { cm_id } = useParams();

  // Создаем app после монтирования компонента, чтобы mobx-react смог среагировать на изменение.
  useEffect(() => {
    if (!appFactory.app) {
      appFactory.createApp();
    }
  }, []);

  const { app } = appFactory;
  if (!app) {
    return null;
  }

  if (!app.initializing && !app.initialized) {
    void app.init(cm_id);
  }

  return (
    <>
      {app.initializing && (
        <div className={styles.BrandMark}>
          <BrandMarkImg />
        </div>
      )}

      {!app.initializing && app.initialized && !app.error && children}

      {!app.initializing && !!app.error && <ErrorView error={app.error} />}
    </>
  );
});
